/**
 * Row kinds in the flat ledger (TRANS4.Trnstype). Confirmed across piopio
 * and champion practices.
 *   65537     - Charge / invoice line (always has InvoiceNumGuid)
 *   86020     - Receipt / payment (allocation via TRNSALLO, no InvoiceNumGuid)
 *   65539     - Adjustment (invoice- vs receipt-side; see AdjustmentType below)
 *   65541     - Transfer leg (mirrors a 65542 row of the opposite sign)
 *   65542     - Transfer leg (mirrors a 65541 row of the opposite sign). Neither
 *               implies a direction — the builder routes them on amount sign.
 *   65556     - Write-off / bad debt (DR-side payment that clears a charge;
 *               comment is "Account Written Off", no payor, no Trnsref,
 *               AdjustedTrnsId points to the original charge)
 *   65558     - Payment plan instalment (charge-side; positive amount, settled
 *               by a later receipt; no InvoiceNumGuid/CotGuid)
 *   65548     - Discount (prompt-payment / manual discount; IsDiscount=true,
 *               negative amount, DR-side in TRNSALLO settling a charge —
 *               behaves like a write-off)
 *   65552     - External / debt-collection credit (DR-side, negative, settles a
 *               charge like a write-off; comment names the agency, e.g. "Bay
 *               Corp"). Treated as an incoming discount by the invoice builder.
 *   536936463 - Deposit / unallocated credit (has DepositNumGuid, no DebtorId)
 *   536936457 - Treatment plan / quote (CotGuid, amounts are planned totals)
 *   536936466 - Prior approval (CotGuid + PayorId)
 *   536936462 - NZ MOH/ACC agreement record
 *
 * Noise kinds — carry no money and are excluded by the query WHERE clause:
 *   536936464  - Statement printed
 *   536936456  - Recall / correspondence printed (zero amount, no allocation)
 *   536936455  - Document printed (zero amount, no links; comment is the
 *                patient's own name)
 *   536936468  - Medicare claim printed (AU; zero amount, no TRNSALLO entry)
 *   4086964342 - Corrupt / invalid row (single junk record, garbage comment)
 *   0          - Empty / init row
 */
export enum ExactV2TransactionType {
  Charge = 65537,
  Receipt = 86020,
  Adjustment = 65539,
  TransferOut = 65541,
  TransferIn = 65542,
  WriteOff = 65556,
  Discount = 65548,
  ExternalCredit = 65552,
  PaymentPlan = 65558,
  Deposit = 536936463,
  TreatmentPlan = 536936457,
  PriorApproval = 536936466,
  AgreementRecord = 536936462,
  // Noise kinds — excluded by the query, never reach the builder.
  StatementPrinted = 536936464,
  RecallPrinted = 536936456,
  DocumentPrinted = 536936455,
  MedicareClaimPrinted = 536936468,
  InvalidJunk = 4086964342,
  Empty = 0,
}

/**
 * Which side an adjustment row applies to.
 * InvoiceSide (1): resubmission, PAYMENTSCH discount, INV_DISCNT.
 * ReceiptSide (2): RECEIPTCOR, REFWZ_REC, REFWZ_COR.
 */
export enum ExactV2AdjustmentType {
  InvoiceSide = 1,
  ReceiptSide = 2,
}
